<template>
  <div>
    <!-- <object :data="commonStore.getAttachmentUrl('promotion', 'pdf') + '#toolbar=0&navpanes=0&scrollbar=0'" type="application/pdf" width="80%" height="1000px" class="m-auto">alt : <a :href="commonStore.getAttachmentUrl('promotion', 'pdf')">promotion.pdf</a></object> -->
    <img src="@/assets/images/promotion/promotion.png" class="m-auto mb-10" style="max-width: 100vw" />
    <ContactBtnGrp class="mb-14" phoneNo="+85237233063" phoneDisplayNo="+852 3723 3063" whatsappNo="85237260622" whatsappDisplayNo="+852 3726 0622" />
  </div>
</template>

<script setup lang="ts">
import ContactBtnGrp from "@/components/shared/ContactBtnGrp.vue";
import { useCommonStore } from "@/stores/common";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";

const commonStore = useCommonStore();
const router = useRouter();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
const getWindowSize = () => {
  return "width:" + window.innerWidth + ";height: " + window.innerHeight;
};
</script>
<style scoped>
</style>
